'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInlinedOperatorsEnabled = getInlinedOperatorsEnabled;
exports.maybeReplaceWithInlinedOperator = maybeReplaceWithInlinedOperator;

var _types = require('../types');

var _types2 = _interopRequireDefault(_types);

var _astLocUtils = require('ast-loc-utils');

var _compilerState = require('../state/compilerState');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// XXX

var inlinedOperator = {
  looseEq: function looseEq(args) {
    return _types2.default.binaryExpression("==", args[0], args[1]);
  },
  looseNotEq: function looseNotEq(args) {
    return _types2.default.binaryExpression("!=", args[0], args[1]);
  },
  bitwiseNot: function bitwiseNot(args) {
    return _types2.default.unaryExpression("~", args[0]);
  },
  bitwiseAnd: function bitwiseAnd(args) {
    return _types2.default.binaryExpression("&", args[0], args[1]);
  },
  bitwiseOr: function bitwiseOr(args) {
    return _types2.default.binaryExpression("|", args[0], args[1]);
  },
  bitwiseXor: function bitwiseXor(args) {
    return _types2.default.binaryExpression("^", args[0], args[1]);
  },
  bitwiseLeftShift: function bitwiseLeftShift(args) {
    return _types2.default.binaryExpression("<<", args[0], args[1]);
  },
  bitwiseRightShift: function bitwiseRightShift(args) {
    return _types2.default.binaryExpression(">>", args[0], args[1]);
  },
  bitwiseZeroFillRightShift: function bitwiseZeroFillRightShift(args) {
    return _types2.default.binaryExpression(">>>", args[0], args[1]);
  }
};

// XXX: factor out to config
function getInlinedOperatorsEnabled(opts) {
  return !(opts.stdlib === false || typeof opts.stdlib === "object" && opts.stdlib.lightscript === false);
}function maybeReplaceWithInlinedOperator(path, callee, args) {
  if (!(0, _compilerState.getCompilerState)().inlinedOperatorsEnabled || // XXX
  callee.type !== "Identifier") return false;
  var name = callee.name;
  if (!inlinedOperator[name] || path.scope.hasBinding(name)) return false;
  path.replaceWith((0, _astLocUtils.placeAtNode)(inlinedOperator[name](args), path.node));
  return true;
}


//////////////////
// WEBPACK FOOTER
// ../~/@oigroup/babel-plugin-lightscript/lib/transforms/inlinedOperators.js
// module id = 998
// module chunks = 0